import type { StoryElement } from '../types';
import { linkHost } from './linkHost';

export interface TopicContextSourceLink {
  label: string;
  href: string;
}

function normalizedHost(value: string): string {
  const candidate = value.includes('://') ? value : `https://${value}`;
  return linkHost(candidate).toLowerCase();
}

/** Resolve the compact source labels emitted by topic context to article URLs. */
export function topicContextSourceLinks(
  story: Pick<StoryElement, 'url' | 'linked_url' | 'canonical_domain' | 'alternatives'>,
  sources: string[],
): TopicContextSourceLink[] {
  const candidates = [
    ...(story.linked_url ? [{ url: story.linked_url, domain: normalizedHost(story.linked_url) }] : []),
    ...(story.url ? [{ url: story.url, domain: story.canonical_domain || normalizedHost(story.url) }] : []),
    ...(story.alternatives || []).map((alternative) => ({
      url: alternative.url,
      domain: alternative.canonical_domain || normalizedHost(alternative.url),
    })),
  ];

  return sources.map((source) => {
    const host = normalizedHost(source);
    const match = candidates.find((candidate) => normalizedHost(candidate.domain) === host);
    return { label: source, href: match?.url || `https://${host}` };
  });
}
